export default __webpack_public_path__ + "static/media/controlInfo24.8ab25471.svg";